// extracted by mini-css-extract-plugin
export default {"aiAssistantWrapper":"AssistantAndToolWrapper__aiAssistantWrapper___ue4Ro"};